import {
    initialSymbolTilesStreamState,
    SymbolTilesStreamState,
} from 'widgets/symbolTile/store/data/SymbolTilesStreamState';
import { StreamMessage } from 'utils/messages/StreamMessage';
import {
    initialPriceStreamsState,
    PriceStreamsState,
} from 'widgets/candlestickTile/store/stream/PriceStreamState';
import {
    initialObvTileStreamsState,
    ObvStreamsState,
} from 'widgets/obvTile/store/stream/ObvTileStreamState';
import {
    initialSignalTileStreamsState,
    SignalTileStreamsState,
} from 'widgets/signalTiles/signalTile/state/stream/SignalTileStreamState';
import { VenueAnalysisStreamsState } from 'widgets/venueAnalysis/store/stream/VenueAnalysisStreamDataState';
import { SymbolInfoStreamsState } from 'widgets/symbolInfo/store/SymbolInfoWidgetState';
import { LiquidityStreamsState } from 'widgets/liquiditySummary/store/data/LiquiditySummaryDataState';
import { FillsGraphStreamedDataStreamsState } from 'widgets/fillsGraph/store/streamedData/FillsGraphStreamedDataHelpers';
import { HistPriceVolStreamsState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState';
import { VolumeCurveStreamsState } from 'widgets/volumeCurve/store/data/VolumeCurveDataState';
import { OrderVolumeProfileStreamsState } from 'widgets/orderVolumeProfile/store/data/OrderVolumeProfileDataState.ts';

export interface StreamState<TStreamDataState> {
    data?: TStreamDataState;
    messages: StreamMessage[];
}

export type StreamsByStreamKeyState<TStreamDataState> = {
    [streamKey: string]: StreamState<TStreamDataState>;
};

export interface StreamedDataState {
    fillsGraphStreamRequestBySymbol: FillsGraphStreamedDataStreamsState;
    histPriceVol: HistPriceVolStreamsState;
    liquidity: LiquidityStreamsState;
    orderVolumeProfile: OrderVolumeProfileStreamsState;
    priceTiles: PriceStreamsState;
    obvTiles: ObvStreamsState;
    pfeTiles: SignalTileStreamsState;
    rsiTiles: SignalTileStreamsState;
    symbolInfo: SymbolInfoStreamsState;
    symbolTiles: SymbolTilesStreamState;
    venueAnalysis: VenueAnalysisStreamsState;
    volumeCurve: VolumeCurveStreamsState;
}

export type StreamedDataKey = keyof StreamedDataState;

export const initialStreamedDataState: StreamedDataState = {
    fillsGraphStreamRequestBySymbol: {},
    histPriceVol: {},
    liquidity: {},
    obvTiles: initialObvTileStreamsState,
    orderVolumeProfile: {},
    pfeTiles: initialSignalTileStreamsState,
    priceTiles: initialPriceStreamsState,
    rsiTiles: initialSignalTileStreamsState,
    symbolInfo: {},
    symbolTiles: initialSymbolTilesStreamState,
    venueAnalysis: {},
    volumeCurve: {},
};
export type StreamedStateByStreamKey<
    TStreamDataState,
    TStreamState extends StreamState<TStreamDataState>,
> = {
    [streamKey: string]: TStreamState;
};
